import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Box, Tabs, Tab, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiCancel } from "react-icons/gi";
import GetAppIcon from "@mui/icons-material/GetApp";

import SparePartTable from "./SparePartTable";
import SparePartExcelToList from "./SparePartExcelToList";
import { FaUpload } from "react-icons/fa";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";

import { getPostExcelUpload, downloadExcelFile } from "../../store/actions/SparePartExcelActions";

export default function SparePartExcelUpload() {
    const ls = localStorage;
    const theme = useTheme();
    const [tabIndexValue, setTabIndexValue] = useState(0);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    const { uploadResponse } = useSelector(({ SparePartExcel }) => SparePartExcel);

    const [sparePartExcel, setSparePartExcel] = useState([]);
    const [fileChecksum, setFileChecksum] = useState("");

    const [formData, setFormData] = useState(new FormData());
    const [warningList, setWarningList] = useState([]);

    const [disableExcel, setDisableExcel] = useState(false);
    const [disableUpload, setDisableUpload] = useState(true);
    const [disableCancel, setDisableCancel] = useState(true);

    useEffect(() => {
        console.log('uploadResponse', uploadResponse?.success);
        if (uploadResponse?.success) {
            setWarningList([]);
            setFormData(new FormData());
            setSparePartExcel([]);
            setDisableUpload(true);
            setDisableExcel(false);
            setDisableCancel(true);
            window.location.reload();
        }
    }, [uploadResponse]);

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (_event, newValue) => {
        setTabIndexValue(newValue);
    };

    const cancelUpload = () => {
        setWarningList([]);
        setDisableCancel(true);
        setDisableExcel(false);
        window.location.reload();
    };

    const uploadExcel = () => {
        let payload = {
            fileChecksum: fileChecksum,
        };

        dispatch(getPostExcelUpload(payload));
    };

    const callBackTabData = (excelData) => {
        if (excelData.excelList.errorCode === 0) {
            setSparePartExcel(excelData.excelList.resultObject.content);
        
            setFileChecksum(excelData.excelList.resultObject.fileChecksum?.hash);
            setDisableExcel(true);
            setDisableCancel(false);
            setDisableUpload(false);

            if (excelData.excelList.resultObject.warnings?.length > 0) {
                setWarningList(excelData?.excelList.resultObject.warnings);
                setDisableUpload(true);
            }
        }
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    return (
        <div>
            <Grid container item md={12}>
                {/* Tabs */}
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Tabs value={tabIndexValue} onChange={handleChange} centered>
                        <Tab label={t("SparePartListExcelUpload")} {...a11yProps(0)}></Tab>                      
                    </Tabs>
                </Grid>

                {/* Empty grid */}
                <Grid item xs={1} sm={3} md={4} lg={4}></Grid>

                {/* Buttons */}
                <Grid item xs={12} sm={6} md={12} lg={4}>
                    {/* Excel File Outline */}
                    <Tooltip title={t("ExcelFileOutline")}>
                        <IconButton
                            onClick={() =>
                                dispatch(
                                    downloadExcelFile({data: {}})
                                )
                            }
                            size="large">
                            <GetAppIcon style={{ color: "#008000", width: 50, height: 50 }} />
                        </IconButton>
                    </Tooltip>

                    {/* Excel Butonu */}
                    <Tooltip title={t("ChooseExcelFile")}>
                        <IconButton component="label" disabled={disableExcel} size="large">
                            <SparePartExcelToList
                                callBackTabData={callBackTabData}
                                setFormData={setFormData}
                                disableExcel={disableExcel}
                            />
                        </IconButton>
                    </Tooltip>

                    {/* İptal Butonu */}
                    <Tooltip title={t("Cancel")}>
                        <IconButton
                            component="label"
                            onClick={cancelUpload}
                            disabled={disableCancel}
                            size="large">
                            <GiCancel style={{ width: 50, height: 50, padding: 0, fill: disableCancel ? "#bdbdbd" : "#E82114" }} />
                        </IconButton>
                    </Tooltip>

                    {/* Upload Butonu */}
                    <Tooltip title={t("DataUpload")}>
                        <IconButton component="label" disabled={disableUpload} size="large">
                            <FaUpload disableUpload={disableUpload} style={{ fill: disableUpload ? "#bdbdbd" : "#00a4b9", width: "50px", height: "50px", padding: "0px" }} onClick={uploadExcel} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={tabIndexValue}
                onChangeIndex={(value) => {
                    setTabIndexValue(value);
                }}
                enableMouseEvents
            >
                {/* callback function'dan gelen data ilgili komponente props olarak gidip tabloyu doldurur */}
                <TabPanel value={tabIndexValue} index={0} dir={theme.direction}>
                    <SparePartTable sparePartExcel={sparePartExcel} warningList={warningList} />
                </TabPanel>
            </SwipeableViews>
            <LoadingBackdrop id="speu_lbd" />
        </div>
    );
}
